// Facebook stats are now fetched via the backend token manager.
// Tokens never touch the browser — the server holds and auto-refreshes them.
//
// Backend endpoint: GET /api/facebook/:pageId/stats
// Returns: { followers, fans, engagement, lastUpdated }

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5000";

export async function getPageStats(pageId) {
  const res  = await fetch(`${API_BASE}/api/facebook/${pageId}/stats`);
  const body = await res.json();
  if (!res.ok) throw new Error(body.error || `Backend error ${res.status}`);
  return {
    followersCount: body.followers  ?? 0,
    followingCount: body.following  ?? null,
    postsCount:     body.postsCount ?? null,
    isLive:         body.isLive     ?? true,
  };
}
